import { __extends } from "tslib";
import React from 'react';
export var GalleryContext;
try {
    GalleryContext = React.createContext({});
}
catch (e) {
    GalleryContext = null;
}
var GalleryProvider = /** @class */ (function (_super) {
    __extends(GalleryProvider, _super);
    function GalleryProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GalleryProvider.prototype.render = function () {
        if (GalleryContext) {
            // const value = { ...this.value, ...this.state };
            return (React.createElement(GalleryContext.Provider, { value: this.state }, this.props.children));
        }
        else {
            return this.props.children;
        }
    };
    return GalleryProvider;
}(React.Component));
export { GalleryProvider };
//# sourceMappingURL=GalleryContext.js.map